import { create } from 'zustand'

const initialState = {
  isMtlsRequired: true,
  mtlsEnabled: false,
  endpoint: ''
}
export const useMtlsCertificateStore = create((set) => ({
  ...initialState,
  setIsMtlsRequired: (value) => set({ isMtlsRequired: value }),
  setMtlsEnabled: (value) => set({ mtlsEnabled: value }),
  setEndpoint: (value) => set({ endpoint: value }),
  logout: () => set(initialState)
}))
